module.exports = __webpack_public_path__ + "static/img/7.8350be7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/2/sp/7.png
// module id = kkEg
// module chunks = 0